<template>
  <div>
    <!-- modal for preview -->
    <div class="modal modal-default fade" id="modal-show">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-success">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.preview')}}</h4>
          </div>
          <div class="modal-body">
            <exercise :bareBonesExercise="CelotnaNaloga" :showAnswer="true"></exercise>
          </div>
          <div class="modal-footer bg-success">
            <button class="btn btn-default pull-right" @click.prevent="toggleShowModal()">{{$t('pages.exerciseList.hide')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- modal for import -->
    <div class="modal modal-primary fade" id="modal-import">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exerciseList.import')}}</h4>
          </div>
          <div id="import-modal-body" class="modal-body">
            <template v-if="!successMsg && !errorMsg">
              <form class="uploadForm" enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
                <div class="dropbox">
                  <input type="file" name="file" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept=".tex" class="input-file">
                  <p v-if="isInitial">
                    {{ $t('pages.adminpanel.exercises.loadExercise')}}<br> {{ $t('pages.adminpanel.exercises.loadExercise2')}}
                  </p>
                  <p v-if="isSaving">
                    {{ $t('pages.adminpanel.exercises.uploading')}}
                  </p>
                </div>
              </form>
            </template>
            <div v-else>
              <div v-if="errorMsg">
                <div class="callout callout-danger">
                  <h4><i class="icon fa fa-ban"></i>Error</h4>
                  <p>{{errorMsg.responseJSON.message}}</p>
                </div>
              </div>
              <div v-else>
                <div class="callout callout-success">
                  <p>{{successMsg.message}}</p>
                </div>
                <div v-if="successMsg.warnings.length > 0" class="panel box box-warning">
                  <div class="box-header with-border">
                    <h4 class="box-title">
                      <a id="warnings-accordion" data-toggle="collapse" data-parent="#accordion" href="#collapseThree">
                        {{successMsg.warnings.length}} 
                        <span v-if="successMsg.warnings.length === 1">warning</span>
                        <span v-else>warnings</span>
                      </a>
                    </h4>
                  </div>
                  <div id="collapseThree" class="panel-collapse collapse">
                    <div class="box-body">
                      <table>
                        <tr v-for="(warning, ix) in successMsg.warnings">
                          <td>
                            <p>
                              {{ix + 1}}.
                              <b>On exercise with id {{warning.exercise}}</b>
                              <span v-if="warning.lineNumber">
                                at line {{warning.lineNumber}}
                              </span> 
                              : {{warning.message}}
                              <br>
                              <div v-if="!warning.lineNumber"> 
                                <span style="font-weight: bold">Context:</span>
                                {{warning.context}}
                              </div>
                            </p>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button v-if="successMsg || errorMsg" class="btn btn-primary" @click.prevent="toUploadForm()">Back</button>
            <button class="btn btn-primary" @click.prevent="toggleImport()">Close</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

      <!-- modal for adding new exercise -->
      <div class="modal modal-primary fade" id="modal-addExec">
      <div class="modal-dialog" style = "width: 40%">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exerciseList.addNew')}}</h4>
          </div>
            <template>
              <p class = "inputExecInfo" >{{$t('pages.exerciseList.chooseNewExecInputMethod')}}</p>
              <button class="btn btn-default execTypeButton" style="margin-bottom: 1em; padding: 10px;" v-on:click = "newExecInputMethod = 'tex'">{{$t('pages.exerciseList.inputMethodLatex')}}</button>
              <button class="btn btn-default execTypeButton" style="margin-bottom: 1em; padding: 10px;" v-on:click = "newExecInputMethod = 'interface'">{{$t('pages.exerciseList.inputMethodInterface')}}</button>
              <button class="btn btn-default execTypeButton" style="margin-bottom: 3em; padding: 10px;" v-on:click = "newExecInputMethod = 'bober'">{{$t('pages.exerciseList.inputMethodBober')}}</button>
            </template>

          <!-- interface for adding exercises via latex (live) -->
            <template v-if = "newExecInputMethod == 'tex'">
              <textarea v-model = "rawLatex" class = "inputLatex">
              </textarea>
              <button class="btn btn-default submitLatexButton" style = "display: block; margin-bottom: 2em;" v-on:click = "submitExecLatex(rawLatex)">{{$t('pages.exerciseList.latexSave')}}</button>
            </template>

            <!-- interface for adding bober exercises -->
            <template v-if = "newExecInputMethod == 'bober'">
              <form id="boberForm" enctype="multipart/form-data" novalidate>
                  <input type="file" name="file" :disabled="isSaving" @change="uploadBoberFile()" accept=".json" id = "bober-input">
                  <p v-if="isSaving">
                    {{ $t('pages.adminpanel.exercises.uploading')}}
                  </p>
              </form>
            </template>

          <!-- interface for inputting basic exercise data (via interface) -->
            <template v-if = "newExecInputMethod == 'interface'">
              <template v-if = "showBasicExecInfo" id = "main-add-exercise">
                <p class = "inputExecInfo">{{$t('pages.exerciseList.inputBasicExecInfo')}}</p>
                <div id = "basicExecInfo">
                  <input v-model = "execID" class = "inputQuestion" type = "text" placeholder = "ID">
                  <input v-model = "execSRC" class = "inputQuestion" type = "text" placeholder = "SOURCE">
                  <p class = "inputQuestion" style = "width: 80%;">PUBLIC <input v-model = "execExposure" style = "margin-left: 1em;" type =  "checkbox"></p>
                </div>
                <p class = "inputExecInfo"> {{$t('pages.exerciseList.execPreText')}}</p>
                <textarea v-model = "execPreText" class = "inputLatex" style = "min-height: 8em; margin-top: 1em; margin-bottom: 2em;"></textarea>
                
                <div style = "margin-top: 3em;">
                  <p class = "inputExecInfo" style = "display: inline;">{{$t('pages.exerciseList.addTags')}}</p>
                  <input placeholder = "TAG-1, TAG-2..." v-model = "execTags" class = "inputQuestion" style = "display: inline; margin-bottom: 2em; width: 65%;">
                </div>
              </template>

              <table style = "width: 100%;">
                <tr>
                  <td style = "width: 50%;">
                    <button v-if = 'showBasicExecInfo' class="btn btn-default" style = "display: block; width: 70%; margin: 0 auto; margin-top: 2em; margin-bottom: 4em;" v-on:click = "showBasicExecInfo = !showBasicExecInfo">{{$t('pages.exerciseList.hideBasicInfo')}}</button>
                    <button v-else class="btn btn-default" style = "display: block; width: 70%; margin: 0 auto; margin-top: 2em; margin-bottom: 4em;" v-on:click = "showBasicExecInfo = !showBasicExecInfo">{{$t('pages.exerciseList.showBasicInfo')}}</button>
                  </td>
                  <td style = "width: 50%;"><button class="btn btn-default" style = "display: block; width: 70%; margin: 0 auto; margin-top: 2em; margin-bottom: 4em;" v-on:click = "addSubExec = !addSubExec">{{$t('pages.exerciseList.addSubExec')}}</button></td>
                </tr>
              </table>

            <!-- interface - add subexercise -->
              <template id = "add-sub-exec" v-if = "addSubExec == true">
                <div id = "choose-exercise-type" class = "modal-body">
                  <p class="inputExecInfo" align = "center" style = "margin-bottom: 2em;">{{$t('pages.exerciseList.chooseExecType')}}</p>
                  <div id = "execTypes" style = "display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; grid-gap: 0.5em;">
                    <button class="btn btn-default" style = "padding: 10px; margin-bottom: 1em;" v-on:click = "exerciseType = 'numerical'">{{$t('pages.exerciseList.typeNumerical')}}</button>
                    <button class="btn btn-default" style = "padding: 10px; margin-bottom: 1em;" v-on:click = "exerciseType = 'radio'">{{$t('pages.exerciseList.typeRadio')}}</button>
                    <button class="btn btn-default" style = "padding: 10px; margin-bottom: 1em;" v-on:click = "exerciseType = 'essay'">{{$t('pages.exerciseList.typeEssay')}}</button>
                    <button class="btn btn-default" style = "padding: 10px; margin-bottom: 1em;" v-on:click = "exerciseType = 'multichoice'">{{$t('pages.exerciseList.typeMultichoice')}}</button>
                    <button class="btn btn-default" style = "padding: 10px; margin-bottom: 1em;" v-on:click = "exerciseType = 'likert'">{{$t('pages.exerciseList.typeLikert')}}</button>
                  </div>
                </div>
              </template>

            <!-- interface for adding numerical type exercises -->
              <template id = "numerical - main" v-if = "(newExecInputMethod == 'interface') && (exerciseType == 'numerical') && addSubExec">
                <p class = "inputExecInfo">Numerical - {{$t('pages.exerciseList.execTypeQuestion')}}</p>
                <input v-model = "numericalQuestion" type = "text" class = "inputQuestion" />
                <table style = "width: 100%; margin-top: 1em;">
                  <tr>
                    <td style = "width: 50%;">
                      <p class = "inputExecInfo" >{{$t('pages.exerciseList.execInputPrecision')}}</p>
                      <input v-model = "numericalPrecision" type = "number" style = "margin: 0em 0em 1em 1em; width: 90%; padding: 0.5em;" step = 0.01 />
                    </td>
                    <td>
                      <p class = "inputExecInfo" >{{$t('pages.exerciseList.execInputAnswer')}}</p>
                      <input v-model = "numericalAnswer" type = "number" style = "margin: 0em 0em 1em 1em; width: 90%; padding: 0.5em;" step = 0.01 />
                    </td>
                  </tr>
                </table>
                <p class = "inputExecInfo" style = "margin-top: 1em;">{{$t('pages.exerciseList.execAddHint')}}</p>
                <input v-model = "numericalHint" type = "text" class = "inputQuestion" />
                <button class="btn btn-default" style = "display:block; margin: 0 auto; margin-top: 3em; margin-bottom: 3em;" v-on:click = "addSubExecNumerical(numericalQuestion, numericalPrecision, numericalAnswer, numericalHint)">{{$t('pages.exerciseList.finishSubExec')}}</button>
              </template>

            <!-- interface for adding radio type exercises -->
              <template id = "radio-main" v-if = "(newExecInputMethod == 'interface') && (exerciseType == 'radio') && addSubExec">
                <p class = "inputExecInfo">Radio - {{$t('pages.exerciseList.execTypeQuestion')}}</p>
                <input v-model = "radioQuestion" type = "text" class = "inputQuestion" />
                <button v-if = "radioAddAnother == false" class = "btn btn-default" style = "display:block; margin: 0 auto; margin-top: 3em; margin-bottom: 3em;" v-on:click = "radioAddAnother = true"> {{$t('pages.exerciseList.radioAddAnswer')}} </button>

                <template id = "radio-add-answer" v-if = "radioAddAnother == true">
                  <table class = "radioAddAnswer">
                  <tr>
                    <td style = "width: 50%;">
                      <p class = "inputExecInfo" >{{$t('pages.exerciseList.execInputAnswer')}}</p>
                      <input v-model = "radioNewAnswer" type = "text" style = "margin: 0em 0em 1em 1em; width: 90%; padding: 0.5em;"/>
                    </td>
                    <td>
                      <p id = "radioNewCheckbox" class = "inputExecInfo" >{{$t('pages.exerciseList.radioAddAnswerIfCorrect')}}</p>
                      <input v-model = "radioNewCheckbox" id = "True" type = "checkbox" style = "margin: 1em 0em 1em 0em; width: 90%; padding: 0.5em;"/>
                    </td>
                  </tr>
                  <tr>
                    <td style = "width: 50%;">
                      <button class = "btn btn-default" style = "margin-left: 1em; width: 90%; margin-bottom: 1em;" v-on:click = "radioAddAnother = false">{{$t('pages.exerciseList.cancel')}}</button>
                    </td>
                    <td>
                      <button class = "btn btn-default" style = "margin-left: 1em; width: 90%; margin-bottom: 1em;" v-on:click = "radioAddAnswer(radioNewAnswer, radioNewCheckbox)">{{$t('pages.exerciseList.radioAddAnswer')}}</button>
                    </td>
                  </tr>
                </table>
                </template>

                <!-- radio - all answers so far -->
                <template id = "radio-answers" v-if = "(radioAllAnswers.length) > 0">
                  <p class = "inputExecInfo" style = "margin-top: 3em;">{{$t('pages.exerciseList.answersSoFar')}}</p>
                  <ul id = "soFarAnswers">
                    <li v-bind:key = "answer" v-for = "answer in radioAllAnswers">
                      <table style = "width: 100%;">
                        <tr>
                          <td style = "width: 90%;"> {{answer.an.text.sl}} | {{answer.an.correct}}</td>
                          <td style = "width: 10%;">
                            <!--<button type="button" class="btn btn-sm btn-default" v-on:click = "toggleEditAns(answer.id)">
                              <i class="fa fa-edit"></i>
                            </button> RADIO: EDIT ANSWERS - MUST BE FIXED - DOESNT WORK PROPERLY -->
                            <button class = "btn btn-danger pull-left" v-on:click = "radioDelAnswer(answer.id)">
                              <span class = "fa fa-trash"></span>
                            </button>
                          </td>
                        </tr>
                      </table>
                    </li>
                  </ul>
                </template>

                <button v-if = "(radioAllAnswers.length) > 0" style = "display:block; margin: 0 auto; margin-bottom: 3em; margin-top: 3em;" class = "btn btn-default" v-on:click = "addSubExecRadio(radioQuestion)">{{$t('pages.exerciseList.finishSubExec')}}</button>
              </template>

            <!-- interface for adding essay type exercises -->
              <template v-if = "(newExecInputMethod == 'interface') && (exerciseType == 'essay') && addSubExec">
                <p class = "inputExecInfo">Essay - {{$t('pages.exerciseList.execTypeQuestion')}}</p>
                <input v-model = "essayQuestion" type = "text" class = "inputQuestion" />
                <p class = "inputExecInfo" style = "margin-top: 2em;">{{$t('pages.exerciseList.execInputAnswer')}}</p>
                <input v-model = "essayAnswer" type = "text" style = "margin-bottom: 1em;" class = "inputQuestion" />
                <p class = "inputExecInfo" style = "margin-top: 2em;">{{$t('pages.exerciseList.execAddHint')}}</p>
                <input v-model = "essayHint" type = "text" class = "inputQuestion" />
                <button class="btn btn-default" style = "display:block; margin: 0 auto; margin-top: 3em; margin-bottom: 3em;" v-on:click = "addSubExecEssay(essayQuestion, essayAnswer, essayHint)">{{$t('pages.exerciseList.finishSubExec')}}</button>
              </template>

            <!-- interface for adding multichoice type exercises -->
              <template v-if = "(newExecInputMethod == 'interface') && (exerciseType == 'multichoice') && addSubExec">
                <p class = "inputExecInfo">Multichoice - {{$t('pages.exerciseList.execTypeQuestion')}}</p>
                <input v-model = "multiQuestion" type = "text" class = "inputQuestion" />
                <button v-if = "radioAddAnother == false" class = "btn btn-default" style = "display:block; margin: 0 auto; margin-top: 3em; margin-bottom: 3em;" v-on:click = "radioAddAnother = true"> {{$t('pages.exerciseList.radioAddAnswer')}} </button>

                <template id = "radio-add-answer" v-if = "radioAddAnother == true">
                  <table class = "radioAddAnswer">
                  <tr>
                    <td style = "width: 50%;">
                      <p class = "inputExecInfo" >{{$t('pages.exerciseList.execInputAnswer')}}</p>
                      <input v-model = "radioNewAnswer" type = "text" style = "margin: 0em 0em 1em 1em; width: 90%; padding: 0.5em;"/>
                    </td>
                    <td>
                      <p id = "radioNewCheckbox" class = "inputExecInfo" >{{$t('pages.exerciseList.radioAddAnswerIfCorrect')}}</p>
                      <input v-model = "radioNewCheckbox" id = "True" type = "checkbox" style = "margin: 1em 0em 1em 0em; padding: 0.5em;"/>
                    </td>
                  </tr>
                  <tr>
                    <td style = "width: 50%;">
                      <button class = "btn btn-default" style = "margin-left: 1em; width: 90%; margin-bottom: 1em;" v-on:click = "radioAddAnother = false">{{$t('pages.exerciseList.cancel')}}</button>
                    </td>
                    <td>
                      <button class = "btn btn-default" style = "margin-left: 1em; width: 90%; margin-bottom: 1em;" v-on:click = "multiAddAnswer(radioNewAnswer, radioNewCheckbox)">{{$t('pages.exerciseList.radioAddAnswer')}}</button>
                    </td>
                  </tr>
                </table>
              </template>

              <!-- multichoice - all answers so far -->
                <template id = "multi-answers" v-if = "(multiAllAnswers.length) > 0">
                  <p class = "inputExecInfo" style = "margin-top: 3em;">{{$t('pages.exerciseList.answersSoFar')}}</p>
                  <ul id = "soFarAnswers">
                    <li v-bind:key = "m_answer" v-for = "m_answer in multiAllAnswers">
                      <table style = "width: 100%;">
                        <tr>
                          <td style = "width: 90%;"> {{m_answer.an.text.sl}} | {{m_answer.an.correct}}</td>
                          <td style = "width: 10%;">
                            <!-- <button type="button" class="btn btn-sm btn-default" v-on:click = "toggleEditAns(m_answer.id)">
                              <i class="fa fa-edit"></i>
                            </button> MULTICHOICE: EDIT ANSWERS - MUST BE FIXED - DOESNT WORK -->
                            <button class = "btn btn-danger pull-left" v-on:click = "multiDelAnswer(m_answer.id)">
                              <span class = "fa fa-trash"></span>
                            </button>
                          </td>
                        </tr>
                      </table>
                    </li>
                  </ul>
                </template>
                <button v-if = "(multiAllAnswers.length) > 0" style = "display:block; margin: 0 auto; margin-bottom: 3em; margin-top: 3em;" class = "btn btn-default" v-on:click = "addSubExecMulti(multiQuestion)">{{$t('pages.exerciseList.finishSubExec')}}</button>
              </template>

            <!-- interface for adding likert type exercises -->
              <template v-if = "(newExecInputMethod == 'interface') && (exerciseType == 'likert') && addSubExec">
                <p class = "inputExecInfo">Liket - {{$t('pages.exerciseList.execTypeQuestion')}}</p>
                <input v-model = "likertQuestion" type = "text" class = "inputQuestion" />
                <button v-if = "likertAddAnother == false" class = "btn btn-default" style = "display:block; margin: 0 auto; margin-top: 3em; margin-bottom: 3em;" v-on:click = "likertAddAnother = true"> {{$t('pages.exerciseList.radioAddAnswer')}} </button>

                <template id = "likert-add-answer" v-if = "likertAddAnother == true">
                  <table class = "likertAddAnswer">
                  <tr>
                    <td>
                      <p class = "inputExecInfo" >{{$t('pages.exerciseList.execInputAnswer')}}</p>
                      <input v-model = "likertNewAnswer" type = "text" style = "margin: 0em 0em 1em 1em; padding: 0.5em;"/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <button class = "btn btn-default" style = "margin-left: 1em; margin-bottom: 1em;" v-on:click = "likertAddAnswer(likertNewAnswer, likertNewCheckbox)">{{$t('pages.exerciseList.radioAddAnswer')}}</button>
                    </td>
                  </tr>
                </table>
              </template>

              <!-- likert - all answers so far -->
                <template id = "likert-answers" v-if = "(likertAllAnswers.length) > 0">
                  <p class = "inputExecInfo" style = "margin-top: 3em;">{{$t('pages.exerciseList.answersSoFar')}}</p>
                  <ul id = "soFarAnswers">
                    <li v-bind:key = "m_answer" v-for = "m_answer in likertAllAnswers">
                      <table style = "width: 100%;">
                        <tr>
                          <td style = "width: 90%;"> {{m_answer.an.text.sl}} | {{m_answer.an.correct}}</td>
                          <td style = "width: 10%;">
                            <button class = "btn btn-danger pull-left" v-on:click = "likertDelAnswer(m_answer.id)">
                              <span class = "fa fa-trash"></span>
                            </button>
                          </td>
                        </tr>
                      </table>
                    </li>
                  </ul>
                </template>
                <button v-if = "(likertAllAnswers.length) > 0" style = "display:block; margin: 0 auto; margin-bottom: 3em; margin-top: 3em;" class = "btn btn-default" v-on:click = "addSubExecLikert(likertQuestion)">{{$t('pages.exerciseList.finishSubExec')}}</button>
              </template>


            <!-- interface - all subexercises so far -->
              <div id = "subExecCountInfo">
                <div style = "margin-top: 2em; margin-bottom: 4em;">
                  <p class = "inputExecInfo" style = "display: inline;">{{$t('pages.exerciseList.currentSubExecCnt')}}{{ subExercises.length }}</p>
                  <button v-if = "subExercises.length > 0" class = "btn btn-default" style = "float: right; margin-right: 2em;" v-on:click = "showSubExercises = !showSubExercises">{{ $t('pages.exerciseList.showHideSub') }}</button>
                </div>
                <div v-if = "(showSubExercises) && (subExercises.length > 0)">
                  <table style = "width: 100%; text-align: center;">
                    <tr>
                      <td class = "inputExecInfo" style = "width: 25%;"> TYPE </td>
                      <td class = "inputExecInfo" style = "width: 25%;"> QUESTION </td>
                      <td class = "inputExecInfo" style = "width: 25%;"> ANSWERS </td>
                      <td class = "inputExecInfo" style = "width: 25%;"> DEL </td>
                    </tr>
                  </table>
                  <ul id = "subExecList">
                    <li class = "subExercise " v-bind:key = "exec" v-for = "exec in subExercises">
                      <table style = "width: 100%;">
                        <tr>
                          <td class = "inputExecInfo" style = "width: 25%; text-align: center;"> {{ exec.ex.type }} </td>
                          <td class = "inputExecInfo" style = "width: 25%; text-align: center;"> {{ exec.ex.text.sl }} </td>
                          <td class = "inputExecInfo" style = "width: 25%; text-align: center;" v-if = "exec.ex.type == 'numerical'"> {{ exec.ex.answers[0].correct }} </td>
                          <td class = "inputExecInfo" style = "width: 25%;" v-if = "(exec.ex.type == 'radio') || (exec.ex.type == 'multichoice')">
                            <ul id = "subExecListRadioAnswers">
                              <li class = "subExecListRadioAnswer" v-bind:key = "ans" v-for = "ans in exec.ex.answers"> {{ans.text.sl}} | {{ans.correct}} </li>
                            </ul>
                          </td>
                          
                          <td class = "inputExecInfo" style = "width: 35%; text-align: center;" v-if = "exec.ex.type == 'essay'"> {{exec.ex.answers[0]}} </td>
                          <td class = "inputExecInfo" style = "width: 15%;">
                            <button class = "btn btn-danger pull-left" v-on:click = "deleteSubExercise(exec.id)">
                              <span style = "float: right;" class = "fa fa-trash"></span>
                            </button>
                          </td>
                        </tr>
                      </table>
                    </li>
                  </ul>
                </div>
              </div>

              <button v-if = "showSubExercises" class = "btn btn-default" style = "display:block; margin: 0 auto; margin-top: 1em; margin-bottom: 3em;" v-on:click = "submitExecInterface(execID, execSRC, execExposure, execPreText, execTags)">{{$t('pages.exerciseList.finishExec')}}</button>
            </template>

          <div class="modal-footer">
            <button v-if="successMsg || errorMsg" class="btn btn-primary" @click.prevent="toUploadForm()">Back</button>
            <button class="btn btn-primary" @click.prevent="toggleAddExercise()">Close</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!-- / .modal-addExec --> 

    <!-- modal - edit answer -->
    <div class="modal modal-primary fade" id="modal-editAns">
              <div class="modal-dialog" style = "width: 80%;">
                <div class="modal-content" style = "padding-top: 1em;">
                  <ul id = "soFarAnswers" v-if = "(exerciseType === 'multichoice') && (multiAllAnswers.length > 0)">
                    <li>{{this.multiAllAnswers[this.ansIndexM].an.text.sl}} | {{this.multiAllAnswers[this.ansIndexM].an.correct}}</li>
                  </ul>
                  <ul id = "soFarAnswers" v-if = "(exerciseType === 'radio') && (radioAllAnswers.length > 0)">
                    <li>{{this.radioAllAnswers[this.ansIndexR].an.text.sl}} | {{this.radioAllAnswers[this.ansIndexR].an.correct}}</li>
                  </ul>
                  <table class = "radioAddAnswer">
                  <tr>
                    <td style = "width: 50%;">
                      <p class = "inputExecInfo" >{{$t('pages.exerciseList.execInputAnswer')}}</p>
                      <input v-model = "tempAnswer" type = "text" style = "margin: 0em 0em 1em 1em; width: 90%; padding: 0.5em;"/>
                    </td>
                    <td>
                      <p id = "radioNewCheckbox" class = "inputExecInfo" >{{$t('pages.exerciseList.radioAddAnswerIfCorrect')}}</p>
                      <input v-model = "tempCheckbox" type = "checkbox" style = "margin: 1em 0em 1em 0em; width: 90%; padding: 0.5em;"/>
                    </td>
                  </tr>
                  <tr>
                    <td style = "width: 50%;">
                      <button class = "btn btn-default" style = "margin-left: 1em; width: 90%; margin-bottom: 1em;" v-on:click = "toggleEditAns(-1)">{{$t('pages.exerciseList.cancel')}}</button>
                    </td>
                    <td>
                      <button class = "btn btn-default" style = "margin-left: 1em; width: 90%; margin-bottom: 1em;" v-on:click = "editAnswer(tempAnswer, tempCheckbox)">{{$t('pages.buttons.save')}}</button>
                    </td>
                  </tr>
                </table>
                </div>
              </div>
            </div>
    <!-- /modal - EditAns --> 

    <!-- modal for import of rating -->
    <div class="modal modal-default fade" id="modal-import-rating">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exerciseList.upload')}}</h4>
          </div>
          <div class="modal-body">
            <div v-if="loadingCSV" style="position: fixed; top: 50%; left: 50%; margin-top: -50px; margin-left: -100px; z-index: 100">
              <pulse-loader :color="spinnerColor" :size="spinnerSize"></pulse-loader>
            </div>
            <div class="row">
              <div class="col-md-6">
                <h4 class="">{{$t('pages.exerciseList.importTitle')}}</h4>
                <template>
                  <form id="ratingCSVForm" class="ratingCSVForm" enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
                    <div class="dropbox">
                      <input type="file" name="file" multiple :disabled="isSaving" @change="filesChangeRating($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept=".csv" class="input-file">
                      <p v-if="isInitial">
                        {{$t("pages.exerciseList.dragToUpload")}}
                      </p>
                      <p v-if="isSaving">
                        {{$t("pages.exerciseList.uploading")}}
                      </p>
                    </div>
                  </form>
                </template>
              </div>
              <div class="col-md-6" style="height: 200px;">
                <h4 class="">{{$t('pages.exerciseList.exportTitle')}}</h4>
                <div style="text-align: center;">
                  <a class="btn btn-app" :class="loadingCSV ? 'disabled' : ''" @click.prevent="downloadRatingCSV()">
                    <i class="fa fa-download"></i> {{$t('pages.exerciseList.downloadCSV')}}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <!-- modal for import -->
    <div class="modal modal-default fade" id="modal-upload">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exerciseList.upload')}}</h4>
          </div>
          <div class="modal-body">
              <template>
                <form class="slika" enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
                  <div class="dropbox">
                    <input type="file" name="file" multiple :disabled="isSaving" @change="filesChangePictures($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file">
                    <p v-if="isInitial">
                      {{$t("pages.profile.userpicture.loadPicture")}}
                      <br> {{$t("pages.profile.userpicture.loadPicture2")}}
                    </p>
                    <p v-if="isSaving">
                      {{$t("pages.profile.userpicture.loadPicture2")}}
                    </p>
                  </div>
                </form>
              </template>
          </div>
          <div class="modal-footer">
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- modal for edit exercise -->
    <div class="modal modal-default fade" id="modal-editExercise">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.editexercise.prompt')}}</h4>
          </div>
          <div class="modal-body">
            <editexercise></editexercise>
          </div>
          <div class="modal-footer">
          <button type="submit" class="btn btn-primary" @click.prevent="submitEdit()">{{ this.$t('pages.profile.update')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modals -->
    <div class="box">
      <div class="box-header">
        <div class="small-box">
          <div class="input-group">
            <input v-model="sid" class="form-control input-lg" type="text" :placeholder="$t('pages.exerciseList.placeholders.dataId')">
            <span class="input-group-addon">
                <button v-bind:class="{ 'bg-blue': sqlidentifier === 1 }" type="button" class="btn btn-xs" @click.prevent="sqlOption('sqlidentifier', 1)">{{$t('pages.exerciseList.contains')}}</button>
                <button v-bind:class="{ 'bg-blue': sqlidentifier === 0 }" type="button" class="btn btn-xs" @click.prevent="sqlOption('sqlidentifier', 0)">{{$t('pages.exerciseList.startWith')}}</button>
            </span>
          </div>
          <a v-if="!advanced" href="#" @click.prevent="toggleAdvanced()">{{$t('pages.exerciseList.showAdvanced')}}</a>
          <a v-else href="#" @click.prevent="toggleAdvanced()">{{$t('pages.exerciseList.hideAdvanced')}}</a>
        </div>
        <div v-if="advanced" class="small-box-footer">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="input-group col-xs-10 margin">
              <input v-model="stitle" class="form-control input-sm" type="text" :placeholder="$t('pages.exerciseList.placeholders.title')">
            </div>
            <div class="input-group col-xs-10 margin">
              <input v-model="sauthor" class="form-control input-sm" type="text" :placeholder="$t('pages.exerciseList.placeholders.author')">
            </div>
            <div class="input-group col-xs-10 margin">
              <input v-model="ssource" class="form-control input-sm" type="text" :placeholder="$t('pages.exerciseList.placeholders.source')">
            </div>
            <div class='margin col-xs-3'> <small>{{$t('pages.exerciseList.owner')}}</small>
                <select v-model="sowner" type="selected">
                  <option>Any</option>
                  <option>True</option>
                  <option>False</option>
                </select>
            </div>
            <!-- <div class="margin col-xs-3"> <small>{{$t('pages.exerciseList.public')}}</small>
                <select v-model="spublic" type="selected">
                  <option>Any</option>
                  <option>True</option>
                  <option>False</option>
                </select>
            </div> -->
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="col-xs-12 margin">
              <div class="input-group">
                <v-select multiple v-model="stags" :options="options.tags" label="name" :placeholder="$t('pages.exerciseList.placeholders.tags')"></v-select>
                <span class="input-group-addon">
                  <button v-bind:class="{ 'bg-blue': sTagFilter === 'or' }" type="button" class="btn btn-xs" @click.prevent="updateTagFilter('or')">or</button>
                  <button v-bind:class="{ 'bg-blue': sTagFilter === 'and' }" type="button" class="btn btn-xs" @click.prevent="updateTagFilter('and')">and</button>
                </span>
              </div>
            </div>
            <div class="col-xs-12 margin">
              <v-select multiple v-model="stagsExclude" :options="options.tags" label="name" :placeholder="$t('pages.exerciseList.placeholders.tagsExclude')"></v-select>
            </div>
            <div class="col-xs-12 margin">
              <v-select multiple v-model="slangs" :options="options.lngs" label="name" :placeholder="$t('pages.exerciseList.placeholders.languages')"></v-select>
            </div>
            <div class="col-xs-12 margin">
              <v-select multiple v-model="stypes" :options="options.types" label="name" :placeholder="$t('pages.exerciseList.placeholders.types')"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="pull-right margin">
              <button class="btn btn-sm btn-default bg-blue" @click.prevent="advancedSearch()">
                <i class="fa fa-search"></i>
                {{$t('pages.exerciseList.search')}}
              </button>
              <a class="small" href="#" @click.prevent="resetSearch()">{{$t('pages.exerciseList.reset')}}</a>
            </div>
          </div>
        </div>
        <div class="row margin">
          <div v-if="!isModal" class="btn-group">
            <button class="btn btn-default" style="margin-right:1em;" @click.prevent="toggleImport()">{{$t('pages.exerciseList.importButton')}}</button>
            <button class="btn btn-default" style="margin-right:1em;" @click.prevent="togglePictures()">{{$t('pages.exerciseList.uploadPictures')}}</button>
            <button class="btn btn-default" style="margin-right:1em;" @click.prevent="toggleRating()">{{$t('pages.exerciseList.importRating')}}</button>
            <button class="btn btn-default" style="margin-right:1em;" @click.prevent="toggleAddExercise()">{{$t('pages.exerciseList.addExerciseButton')}}</button>
            <button class="btn btn-default" style="margin-right:1em;" @click.prevent="manageClassrooms()">{{$t('pages.exams.classrooms.manageClassrooms')}}</button>

            <button v-if="selected.length > 0 && selectedSubgroup" type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">{{selectedSubgroup.name}}
              <span class="fa fa-caret-down"></span>
            </button>
            <button v-if="selected.length > 0 && !selectedSubgroup" type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">{{$t('pages.exerciseList.addToSubgroup')}}
              <span class="fa fa-caret-down"></span>
            </button>
            <ul class="dropdown-menu">
              <li v-for="sgr in subgroupList" v-bind:key="'s-list-'+sgr.id">
                <a @click.prevent="updateSubgroup(sgr)">{{sgr.name}}</a>
              </li>
            </ul>
            <button v-if="selected.length > 0 && !selectedSubgroup" type="button" class="btn btn-danger" @click.prevent="deleteExercises()" style="margin-left:1em;">
              <span class="fa fa-trash"></span>
            </button>
            <button v-if="selected.length > 0 && selectedSubgroup" type="button" class="btn btn-default bg-blue" @click.prevent="addExercises()">{{$t('pages.exerciseList.add')}}</button>
            <label v-if="add" class="margin text-green">{{$t('pages.exerciseList.updated')}}</label>
            <label v-if="deleted" class="margin text-green">{{$t('pages.exerciseList.deleted')}}</label>
            <label v-if="latexSuccessfullyImported || interfaceSuccessfullyImported" class="margin text-green">{{$t('pages.exerciseList.latexSuccessfullyImported')}}</label>
          </div>
          <div v-else class="btn-group">
            <button v-if="selected.length > 0 && !selectedSubgroup" type="button" class="btn btn-danger" @click.prevent="deleteExercises()">
              <span class="fa fa-trash"></span>
            </button>
            <label v-if="deleted" class="margin text-green">{{$t('pages.exerciseList.deleted')}}</label>
          </div>
          <div class="btn-group pull-right">
            <div class="margin">
              <label>{{$t("pages.exerciseList.nmPerPage")}}</label>
              <div class="btn-group">
                <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">{{this.scount}}
                  <span class="fa fa-caret-down"></span>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <a href="#" @click.prevent="updatescount(10)">10</a>
                  </li>
                  <li>
                    <a href="#" @click.prevent="updatescount(25)">25</a>
                  </li>
                  <li>
                    <a href="#" @click.prevent="updatescount(50)">50</a>
                  </li>
                  <li>
                    <a href="#" @click.prevent="updatescount(100)">100</a>
                  </li>
                  <li>
                    <a href="#" @click.prevent="updatescount('all')">{{$t('pages.exerciseList.showAll')}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box-header -->

      <!-- ALL EXERCISES TABLE -->
      <div class="box-body table-responsive no-padding">
        <table class="table table-hover">
          <tbody>
            <tr>
              <th>
                <a class="btn btn-xs">
                  <i v-if="selected.length > 0" class="fa fa-minus-square-o icon" @click="selectAll(0)" style="font-size: 18px;"></i>
                  <i v-else class="fa fa-check-square-o icon" @click="selectAll(1)" style="font-size: 18px;"></i>
                </a>
              </th>
              <th>{{$t("pages.exerciseList.tableId")}}
                <span v-if="ssortby == 'id'">
                  <a v-if="ssortorder == 'desc'" @click.prevent="updatessortorder('asc')">
                    <i class="fa fa-sort-down"></i>
                  </a>
                  <a v-if="ssortorder == 'asc'" @click.prevent="updatessortorder('desc')">
                    <i class="fa fa-sort-up"></i>
                  </a>
                </span>
                <span v-else>
                  <a @click.prevent="updatessortby('id'); updatessortorder('asc')">
                    <i class="fa fa-unsorted"></i>
                  </a>
                </span>
              </th>
              <th>{{$t("pages.exerciseList.tableDataId")}}
                <span v-if="ssortby == 'identifier'">
                  <a v-if="ssortorder == 'desc'" @click.prevent="updatessortorder('asc')">
                    <i class="fa fa-sort-down"></i>
                  </a>
                  <a v-if="ssortorder == 'asc'" @click.prevent="updatessortorder('desc')">
                    <i class="fa fa-sort-up"></i>
                  </a>
                </span>
                <span v-else>
                  <a @click.prevent="updatessortby('identifier'); updatessortorder('asc')">
                    <i class="fa fa-unsorted"></i>
                  </a>
                </span>
              </th>
              <th>{{$t('pages.exerciseList.tableTitle')}}</th>
              <th>{{$t("pages.exerciseList.tableTags")}}</th>
              <th>{{$t("pages.exerciseList.tableAuthor")}}
                <span v-if="ssortby == 'author'">
                  <a v-if="ssortorder == 'desc'" @click.prevent="updatessortorder('asc')">
                    <i class="fa fa-sort-down"></i>
                  </a>
                  <a v-if="ssortorder == 'asc'" @click.prevent="updatessortorder('desc')">
                    <i class="fa fa-sort-up"></i>
                  </a>
                </span>
                <span v-else>
                  <a @click.prevent="updatessortby('author'); updatessortorder('asc')">
                    <i class="fa fa-unsorted"></i>
                  </a>
                </span>
              </th>
              <th>{{$t("pages.exerciseList.tableSource")}}
                <span v-if="ssortby == 'source'">
                  <a v-if="ssortorder == 'desc'" @click.prevent="updatessortorder('asc')">
                    <i class="fa fa-sort-down"></i>
                  </a>
                  <a v-if="ssortorder == 'asc'" @click.prevent="updatessortorder('desc')">
                    <i class="fa fa-sort-up"></i>
                  </a>
                </span>
                <span v-else>
                  <a @click.prevent="updatessortby('source'); updatessortorder('asc')">
                    <i class="fa fa-unsorted"></i>
                  </a>
                </span>
              </th>
              <th>
                <p>{{ $t('pages.reports.reported')}}</p>
              </th>
              <th>
                <p>Edit</p>
              </th>
            </tr>
            <template v-for="(exe, index, index2) in exercises.results">
              <tr :key="'er-'+index" >
                <td>
                  <input type="checkbox" :value="exe.exerciseVersionId" v-model="selected" v-if="forExam">
                  <input type="checkbox" :value="exe.exerciseId" v-model="selected" v-else>
                </td>
                <td>{{exe.id}}</td>
                <td v-if="!isModal">
                  <a href="#" @click.prevent="openModal(exe)">{{exe.identifier}}</a>
                </td>
                <td v-if="isModal" style="height: 0px;">
                  <p>
                    <a data-toggle="collapse" data-parent="#accordion" :href="'#collapse' + exe.id" aria-expanded="false" class="collapsed" @click.prevent="openPanel(exe)">
                      {{exe.identifier}}
                    </a>
                  </p>
                </td>
                <td v-if="isModal" style="width: 12em" :title="$options.filters.pickTranslation(exe.title)">
                  {{shortenTitle(exe.title) | pickTranslation}} <span v-if="exe.title && $options.filters.pickTranslation(exe.title).length > 24">...</span>
                </td>
                <td v-else-if="!isModal" style="width: 15em" data-widget="tooltip" :title="$options.filters.pickTranslation(exe.title)">
                  {{shortenTitle(exe.title) | pickTranslation}} <span v-if="exe.title && $options.filters.pickTranslation(exe.title).length > 30">...</span>
                </td>
                <td>
                  <span v-for="tag in exe.tags">
                    <div class="badge bg-blue">{{tag.name}}</div>
                  </span>
                </td>
                <td>{{exe.author}}</td>
                <td>{{exe.source}}</td>
                <!-- <td>{{getDate(exe.createdAt)}}</td> -->
                <!-- <td>{{getDate(exe.updatedAt)}}</td> -->
                <td><button class = "eyeIconReport" @click.prevent = 'getReports(exe.exerciseId)'> <i class="fa fa-eye  "></i> </button></td>
                <td v-if="!isModal">
                  <button type="button" class="btn btn-sm btn-default" @click.prevent="editExercise(exe.id)">
                    <i class="fa fa-edit"></i>
                  </button>
                </td>
              </tr>
              <tr :key="'e-modal-'+exe.id" v-if="isModal" v-show="exe.id == isOpen">
                <td colspan="8">
                  <div :id="'collapse' + exe.id" class="panel box box-primary panel-collapse collapse" aria-expanded="false" style="width: 100%">
                    <div class="box-body">
                      <exercise :bareBonesExercise="CelotnaNaloga" :showAnswer="true"></exercise>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

    <!-- modal to show all reports on given exercise -->
    <div class="modal modal-default fade" id="modal-showReports">
      <div class="modal-dialog" style = "width: 40%;">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.reports.reportsOnExec')}}id: {{reportExecId}}</h4>
          </div>
          <div class="modal-body">
            <table v-if = 'tempExerciseReports.length > 0' class="table">
              <p>Total: {{tempExerciseReports.length}}</p>
              <tbody>
              <th> {{$t('pages.reports.reportUserId')}} </th>
              <th> {{$t('pages.reports.reportDescription')}} </th>
              <th> {{$t('pages.reports.reportStatus')}} </th>
              <th> {{$t('pages.reports.reportReact')}} </th>

              <tr v-for = 'report in tempExerciseReports' :key = 'report.status'>
                <td style =  "width: 20%">{{report.userId}}</td>
                <td style =  "width: 45%">{{report.description}}</td>
                <td style =  "width: 20%">{{report.status}}</td>
                <td style =  "width: 15%">
                  <button class = "reportReactIcon" @click.prevent="resolveReport(report.id, report.exerciseId) + toggleShowReports()">✓</button>
                  <button class = "reportReactIcon" @click.prevent="ignoreReport(report.id, report.exerciseId)  + toggleShowReports()">✕</button>
                  <button class = "reportReactIcon" @click.prevent="pendingReport(report.id, report.exerciseId)  + toggleShowReports()">…</button>
                </td>
              </tr>
              </tbody>
            </table>
            <p v-else class = 'modal-title'>{{$t('pages.reports.noReportsFound')}}</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click.prevent="toggleShowReports()">Close</button>
          </div>
        </div>
      </div>
    </div>
    <!-- /modal-showReports --> 

      <div class="row margin">
        <div class="col-sm-5" style="margin-top: 1px">
          <tr v-if="exercises.totalPageCount > 1">
            {{$t("pages.exerciseList.footSentence.senOne")}} {{exercises.count}} {{$t("pages.exerciseList.footSentence.senTwo")}} {{exercises.totalResultsCount}} {{$t("pages.exerciseList.footSentence.senThree")}}
          </tr>
          <tr v-else>
            {{$t("pages.exerciseList.footSentence.senOne")}} {{exercises.totalResultsCount}} {{$t("pages.exerciseList.footSentence.senTwo")}} {{exercises.totalResultsCount}} {{$t("pages.exerciseList.footSentence.senThree")}}
          </tr>
        </div>
        <div class="pull-right">
          <div class="dataTables_paginate paging_simple_numbers" id="example1_paginate">
            <ul class="pagination">
              <li>
                <a href="#" v-if="exercises.page != 1" @click.prevent="goToPage(exercises.page-1)">{{$t('pages.exerciseList.previous')}}</a>
              </li>
              <li class="paginate_button active">
                <a>{{$t('pages.exerciseList.page')}} {{exercises.page}} {{$t('pages.exerciseList.of')}} {{exercises.totalPageCount}}</a>
              </li>
              <li>
                <a href="#" v-if="exercises.page != exercises.totalPageCount" @click.prevent="goToPage(exercises.page+1)">{{$t('pages.exerciseList.next')}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Rest from './../../services/rest'
  import router from './../../router/router.js'
  import { mapState } from 'vuex'
  import Exercise from '@/components/exercises/Exercise.vue'
  import editexercise from './../admin/EditExercise'
  import vSelect from 'vue-select'
  import { saveAs } from 'file-saver/FileSaver'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  const moment = require('moment')
  const STATUS_INITIAL = 0
  const STATUS_SAVING = 1
  export default {
    data () {
      return {
        exercises: [],
        selected: [],
        advanced: false,
        sid: '',
        sqlsid: '',
        stitle: '',
        sauthor: '',
        ssource: '',
        stags: [],
        sTagFilter: 'or',
        stagsExclude: [],
        slangs: [],
        stypes: [],
        sowner: 'Any',
        spublic: 'Any',
        // ******************************* add exercise via interface - variables
        showBasicExecInfo: true,
        exerciseType: '',
        execID: '',
        execSRC: '',
        execExposure: false,
        execTags: [],
        execPreText: '',
        addSubExec: false,
        showSubExercises: false,
        numericalQuestion: '',
        numericalAnswer: 0,
        numericalPrecision: 0,
        radioQuestion: '',
        radioNewAnswer: '',
        radioNewChecbox: false,
        essayQuestion: '',
        essayAnswer: '',
        essayHint: '',
        subExercises: [],
        newExecInputMethod: '',
        radioAddAnother: false,
        radioAllAnswers: [],
        likertAddAnother: false,
        likertAllAnswers: [],
        radioCorrectCount: 0,
        multiAllAnswers: [],
        ansIndexR: 0,
        ansIndexM: 0,
        tempAnswer: '',
        tempCheckbox: '',
        rawLatex: '',
        latexSuccessfullyImported: false,
        interfaceSuccessfullyImported: false,
        // ******************************* add exercise via interface - structures
        questionNumerical: {
          'type': 'numerical',
          'text': {
            'sl': ''
          },
          'hints': [],
          'solution': {
            'sl': ''
          },
          'tags': [],
          'answers': [
            {
              'correct': '',
              'precision': '',
              'guid': ''
            }
          ],
          'isQuestionnaire': false,
          'breadcrumbs': {
            'section': null,
            'subsection': null
          },
          'guid': ''
        },
        questionRadio: {
          'type': 'radio',
          'text': {
            'sl': ''
          },
          'hints': [],
          'solution': null,
          'tags': [],
          'answers': [],
          'isQuestionnaire': false,
          'breadcrumbs': {
            'section': null,
            'subsection': null
          },
          'guid': ''
        },
        answerRadio: {
          'correct': false,
          'text': {
            'sl': ''
          },
          'guid': ''
        },
        questionEssay: {
          'type': 'essay',
          'text': {
            'sl': ''
          },
          'hints': [],
          'solution': '',
          'tags': [],
          'answers': [
          ],
          'isQuestionnaire': true,
          'breadcrumbs': {
            'section': null,
            'subsection': null
          },
          'guid': ''
        },
        questionLikert: {
          'type': 'likert',
          'text': {
            'sl': ''
          },
          'hints': [],
          'solution': null,
          'tags': [],
          'answers': [],
          'isQuestionnaire': false,
          'breadcrumbs': {
            'section': null,
            'subsection': null
          },
          'guid': ''
        },
        // bonus
        ssortby: 'id',
        ssortorder: 'asc',
        spage: 1,
        scount: 10,
        // sql helpers
        sqlidentifier: 1,
        options: {},
        // subgroups
        subgroupList: [],
        selectedSubgroup: '',
        add: false,
        deleted: false,
        // import exercise
        currentStatus: null, // begin upload
        fileCount: null, // end upload
        errorMsg: null,
        successMsg: null,
        // panel
        isOpen: null,
        submittedExercise: {
          'id': '',
          'source': '',
          'author': null,
          'tags': [
          ],
          'title': {
            'sl': ''
          },
          'content': [
            {
              'sl': ''
            },
            {
              'isQuestion': true,
              'index': 0
            },
            {
              'isQuestion': true,
              'index': 1
            }
          ],
          'questions': [],
          'tex': '',
          'metadata': {
            'year': null,
            'page': null
          },
          'text': {
            'sl': '' // navodila
          },
          'lngs': [
            'sl'
          ],
          'breadcrumbs': {
            'document': {
              'title': null,
              'author': null
            },
            'chapter': null,
            'section': null,
            'subsection': null
          },
          'guid': ''
        },
        // reports etc
        tempExerciseReports: [],
        reportExecId: 0,
        spinnerColor: '#3c8dbc',
        spinnerSize: '50px',
        loadingCSV: false
      }
    },
    components: {
      'v-select': vSelect,
      'exercise': Exercise,
      'pulse-loader': PulseLoader,
      editexercise
    },
    computed: {
      ...mapState({
        CelotnaNaloga: state => state.exerciseForModal
      }),
      isInitial () {
        return this.currentStatus === STATUS_INITIAL
      },
      isSaving () {
        return this.currentStatus === STATUS_SAVING
      },
      sqltitle () {
        if (this.stitle !== '') {
          return '%' + this.stitle + '%'
        } else {
          return ''
        }
      },
      sqlauthor () {
        if (this.sauthor !== '') {
          return '%' + this.sauthor + '%'
        } else {
          return ''
        }
      },
      sqlsource () {
        if (this.ssource !== '') {
          return '%' + this.ssource + '%'
        } else {
          return ''
        }
      },
      sqltags () {
        return this.stags.map(nm => nm.id)
      },
      sqltagsExclude () {
        return this.stagsExclude.map(nm => nm.id)
      },
      sqllangs () {
        return this.slangs.map(nm => nm.id)
      },
      sqltypes () {
        return this.stypes.map(nm => nm.id)
      },
      isModal () {
        return this.$route.name !== 'library'
      },
      forExam () {
        return this.$route.name === 'editExam'
      },
      selectOwner () {
        if (this.sowner === 'Any') {
          return null
        } else if (this.sowner === 'True') {
          return true
        } else {
          return false
        }
      },
      selectPublic () {
        if (this.spublic === 'Any') {
          return null
        } else if (this.spublic === 'True') {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      toUploadForm () {
        this.successMsg = null
        this.errorMsg = null
      },
      reset () {
        this.currentStatus = STATUS_INITIAL
      },
      save () { // upload data to the server
        this.currentStatus = STATUS_SAVING
        this.successMsg = null
        this.errorMsg = null
        let formData = new FormData(window.jQuery('.uploadForm')[0])
        return Rest.requestForm('POST', '/importer/exerciseUpload', formData).then((data) => {
          this.reset()
          this.successMsg = data
          this.getExercises()
        }).catch((err) => {
          this.reset()
          this.errorMsg = err
          console.log(err)
        })
      },
      filesChange (fieldName, fileList) {
        if (!fileList.length) return
        this.save()
      },
      openModal (exe) {
        this.$store.dispatch('updateModalForExercise', exe.id).then(() => {
          this.$store.commit('updateQuestionObject', {key: 'lngs', value: this.CelotnaNaloga.lngs})
          this.$nextTick(function () {
            window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
          })
          window.jQuery('#modal-show').modal('toggle')
        })
      },
      openPanel (exe) {
        this.closePanels()
        this.$store.dispatch('updateModalForExercise', exe.id).then(() => {
          this.$store.commit('updateQuestionObject', {key: 'lngs', value: this.CelotnaNaloga.lngs})
          this.$nextTick(function () {
            window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
            this.isOpen = exe.id
          })
        })
      },
      closePanels () {
        let $ = window.jQuery
        $('#collapse' + this.isOpen).collapse('hide')
        // this.isOpen = null
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      sqlOption (id, value) {
        if (id === 'sqlidentifier') {
          this.sqlidentifier = value
          if (value === 0) {
            this.sqlsid = this.sid + '%'
          } else {
            this.sqlsid = '%' + this.sid + '%'
          }
          this.getExercises()
        }
      },
      getDate (ct) {
        return moment(ct).format('MM/DD/YYYY HH:mm')
      },
      getOptions () {
        return Rest.request('GET', '/exercises/searchOptions').then((data) => {
          this.options = data
        }).catch((err) => {
          console.log(err)
        })
      },
      advancedSearch () {
        this.spage = 1
        this.getExercises()
      },
      resetSearch () {
        this.sid = ''
        this.sqlsid = ''
        this.stitle = ''
        this.sauthor = ''
        this.ssource = ''
        this.stags = []
        this.stagsExclude = []
        this.slangs = []
        this.stypes = []
        this.sowner = 'Any'
        this.spublic = 'Any'
        this.getExercises()
      },
      getExercises () {
        this.closePanels()
        let postdata = {
          identifier: this.sqlsid,
          title: this.sqltitle,
          author: this.sqlauthor,
          source: this.sqlsource,
          tagIds: this.sqltags,
          tagFilterType: this.sTagFilter,
          tagExcludeIds: this.sqltagsExclude,
          lngIds: this.sqllangs,
          typeIds: this.sqltypes,
          isOwner: this.selectOwner,
          isPublic: this.selectPublic,
          sortBy: this.ssortby,
          sortOrder: this.ssortorder,
          page: this.spage,
          count: this.scount
        }
        if (postdata.count === 0) {
          postdata.count = 1
        }
        return Rest.request('POST', '/exercises/searchPaginated', postdata).then((data) => {
          this.exercises = data
          console.log(this.exercises)
          this.selected = []
        }).catch((err) => {
          console.log(err)
        })
      },
      getReports (exeID) {
        this.reportExecId = exeID
        let postdata = {
          exerciseIdentifier: exeID
        }
        return Rest.request('POST', '/exerciseReports/getReports', postdata).then((data) => {
          this.tempExerciseReports = data
          this.toggleShowReports()
        }).catch((err) => {
          console.log(err)
        })
      },
      resolveReport (reportID, execID) {
        let postdata = {
          report: reportID,
          onExec: execID
        }
        return Rest.request('POST', '/exerciseReports/resolveReport', postdata).then((data) => {
          this.getReports(execID)
        }).catch((err) => {
          console.log(err)
        })
      },
      ignoreReport (reportID, execID) {
        let postdata = {
          report: reportID,
          onExec: execID
        }
        return Rest.request('POST', '/exerciseReports/ignoreReport', postdata).then((data) => {
          this.getReports(execID)
        }).catch((err) => {
          console.log(err)
        })
      },
      pendingReport (reportID, execID) {
        let postdata = {
          report: reportID,
          onExec: execID
        }
        return Rest.request('POST', '/exerciseReports/pendingReport', postdata).then((data) => {
          this.getReports(execID)
        }).catch((err) => {
          console.log(err)
        })
      },
      updateTagFilter (str) {
        this.sTagFilter = str
      },
      updatessortby (sr) {
        this.ssortby = sr
      },
      updatessortorder (so) {
        this.ssortorder = so
        this.spage = 1
        this.getExercises()
      },
      updatescount (nm) {
        this.spage = 1
        if (isNaN(nm)) {
          this.scount = this.exercises.totalResultsCount
        } else this.scount = nm
        this.getExercises()
      },
      goToPage (nm) {
        this.spage = nm
        this.getExercises()
      },
      selectAll (ix) {
        this.add = false
        this.deleted = false
        if (ix === 1) {
          if (this.forExam) {
            this.selected = this.exercises.results.map(exe => exe.exerciseVersionId)
          } else {
            this.selected = this.exercises.results.map(exe => exe.exerciseId)
          }
        } else {
          this.selected = []
        }
        if (this.isModal) {
          this.$store.commit('updateSelectedExercises', this.selected)
        }
      },
      getSubgroups () {
        return Rest.request('GET', '/subgroups/me').then(data => {
          this.subgroupList = data.filter((sgr) => sgr.isLeaf)
        }).catch(function (err) {
          console.log(err)
        })
      },
      updateSubgroup (sgr) {
        this.add = false
        this.deleted = false
        this.selectedSubgroup = sgr
      },
      manageClassrooms () {
        router.push({name: 'classrooms'})
      },
      addExercises () {
        let postdata = {
          exerciseIds: this.selected
        }
        return Rest.request('POST', '/subgroups/' + this.selectedSubgroup.id + '/exercises', postdata).then((data) => {
          this.add = true
        }).catch((err) => {
          console.log(err)
        })
      },
      deleteExercises () {
        let postdata = {
          exerciseIds: this.selected
        }
        return Rest.request('DELETE', '/exercises', postdata).then((data) => {
          this.deleted = true
          this.getExercises()
        }).catch((err) => {
          this.deleted = false
          console.log(err)
        })
      },
      radioAddAnswer (answer, correctAns) {
        if (answer.length > 0) {
          if (correctAns === true) {
            if (this.radioCorrectCount === 0) {
              let tempRadioAnswer = JSON.parse(JSON.stringify(this.answerRadio))

              tempRadioAnswer.correct = correctAns
              tempRadioAnswer.text.sl = answer

              this.radioAllAnswers.push({
                id: this.radioAllAnswers.length,
                an: tempRadioAnswer})
              this.radioCorrectCount++
            } else {
              alert('radio type questions can have only one true answer')
            }
          } else {
            let tempRadioAnswer = JSON.parse(JSON.stringify(this.answerRadio))
            tempRadioAnswer.correct = correctAns
            tempRadioAnswer.text.sl = answer
            this.radioAllAnswers.push({
              id: this.radioAllAnswers.length,
              an: tempRadioAnswer})
          }
          this.resetRadioAns()
        }
      },
      multiAddAnswer (answer, correctAns) {
        if (answer.length > 0) {
          let tempRadioAnswer = JSON.parse(JSON.stringify(this.answerRadio))
          tempRadioAnswer.correct = correctAns
          tempRadioAnswer.text.sl = answer
          this.multiAllAnswers.push({
            id: this.multiAllAnswers.length,
            an: tempRadioAnswer
          })
          this.resetRadioAns()
        }
      },
      radioDelAnswer (ansId) {
        // check if answer to delete is correct (so you can add new correct answer)
        for (let i = 0; i < this.radioAllAnswers.length; i++) {
          if (this.radioAllAnswers[i].id === ansId) {
            if (this.radioAllAnswers[i].an.correct === true) {
              this.radioCorrectCount--
            }
          }
        }
        this.radioAllAnswers.splice(ansId, 1)
        // rearrange indexes
        for (let i = 0; i < this.radioAllAnswers.length; i++) {
          this.radioAllAnswers[i].id = i
        }
      },
      multiDelAnswer (ansId) {
        this.multiAllAnswers.splice(ansId, 1)
        // rearrange indexes
        for (let i = 0; i < this.multiAllAnswers.length; i++) {
          this.multiAllAnswers[i].id = i
        }
      },
      likertAddAnswer (answer, correctAns) {
        if (answer.length > 0) {
          let tempRadioAnswer = JSON.parse(JSON.stringify(this.answerRadio))
          console.log('lar', tempRadioAnswer)
          tempRadioAnswer.correct = true
          tempRadioAnswer.text.sl = answer
          this.likertAllAnswers.push({
            id: this.likertAllAnswers.length,
            an: tempRadioAnswer
          })
          this.reset()
        }
      },
      likertDelAnswer (answer) {
        console.log('answ', answer, this.likertAllAnswers)
        this.likertAllAnswers.splice(answer, 1)
        // rearrange indexes
        for (let i = 0; i < this.likertAllAnswers.length; i++) {
          this.likertAllAnswers[i].id = i
        }
      },
      resetLikert () {
        this.likertAllAnswers = []
        this.likertCorrectCount = 0
        this.likertQuestion = ''
      },
      editAnswer (answer, correctAns) {
        if (answer.length > 0) {
          if (this.exerciseType === 'radio') {
            this.radioDelAnswer(this.ansIndex)
            this.radioAddAnswer(answer, correctAns)
          } else if (this.exerciseType === 'multichoice') {
            this.multiDelAnswer(this.ansIndex)
            this.multiAddAnswer(answer, correctAns)
          }
        }
        this.tempAnswer = ''
        window.jQuery('#modal-editAns').modal('toggle')
        this.radioAddAnother = false
      },
      addSubExecLikert (question) {
        if (question.length > 0) {
          let tempLikertExec = this.questionLikert
          console.log('asel', tempLikertExec)
          tempLikertExec.text.sl = question
          this.subExercises.push({
            id: this.subExercises.length,
            ex: tempLikertExec})
          this.resetLikert()
        }
      },
      addSubExecNumerical (question, precisionExp, answer, hint) {
        if (question.length > 0) {
          let tempNumExec = JSON.parse(JSON.stringify(this.questionNumerical))
          tempNumExec.text.sl = question
          tempNumExec.hints.push(hint)
          tempNumExec.answers[0].correct = answer
          tempNumExec.answers[0].precision = precisionExp
          this.subExercises.push({
            id: this.subExercises.length,
            ex: tempNumExec})
          this.resetNumerical()
        }
      },
      addSubExecRadio (question, hintRadio) {
        if (question.length > 0 && this.radioAllAnswers.length > 0) {
          let tempRadioExec = JSON.parse(JSON.stringify(this.questionRadio))

          tempRadioExec.text.sl = question
          tempRadioExec.hints.push(hintRadio)
          tempRadioExec.answers = []
          for (let i = 0; i < this.radioAllAnswers.length; i++) {
            tempRadioExec.answers[i] = this.radioAllAnswers[i].an
          }
          this.subExercises.push({
            id: this.subExercises.length,
            ex: tempRadioExec})
          this.resetRadioQuestion()
        }
      },
      addSubExecMulti (question, hintRadio) {
        if (question.length > 0 && this.multiAllAnswers.length > 0) {
          let tempMultiExec = JSON.parse(JSON.stringify(this.questionRadio))
          tempMultiExec.type = 'multichoice'
          tempMultiExec.text.sl = question
          tempMultiExec.hints.push(hintRadio)
          tempMultiExec.answers = []
          for (let i = 0; i < this.multiAllAnswers.length; i++) {
            tempMultiExec.answers[i] = this.multiAllAnswers[i].an
          }
          this.subExercises.push({
            id: this.subExercises.length,
            ex: tempMultiExec})
          this.multiAllAnswers = []
          this.addSubExec = !this.addSubExec
          this.exerciseType = 'any'
        }
      },
      addSubExecEssay (question, answer, hint) {
        if (question.length > 0 && answer.length > 0) {
          let tempEssayExec = JSON.parse(JSON.stringify(this.questionEssay))
          tempEssayExec.text.sl = question
          tempEssayExec.hints.push(hint)
          tempEssayExec.answers.push(answer)
          this.subExercises.push({
            id: this.subExercises.length,
            ex: tempEssayExec})
          this.resetEssay()
        }
      },
      deleteSubExercise (exerciseID) {
        this.subExercises.splice(exerciseID, 1)
        // rearrange indexes
        for (let i = 0; i < this.subExercises.length; i++) {
          this.subExercises[i].id = i
        }
      },
      submitExecLatex (rawLatex) {
        if (rawLatex.length > 0) {
          let postdata = {
            latex: rawLatex
          }
          return Rest.request('POST', '/importer/addExecViaLatex', postdata).then((data) => {
            rawLatex = ''
            this.latexSuccessfullyImported = !this.latexSuccessfullyImported
            this.getExercises()
            this.successMsg = data
            window.jQuery('#modal-addExec').modal('toggle')
          }).catch((err) => {
            console.log(err)
          })
        }
      },
      submitExecInterface (execID, execSRC, execExposure, execPreText, execTags) {
        if (execID && execSRC) {
          let finishedExercise = JSON.parse(JSON.stringify(this.submittedExercise))
          finishedExercise.id = execID
          finishedExercise.source = execSRC
          finishedExercise.text.sl = execPreText
          finishedExercise.questions = []
          for (let i = 0; i < this.subExercises.length; i++) {
            finishedExercise.questions[i] = this.subExercises[i].ex
          }
          finishedExercise.tex = 'ADDED VIA INTERFACE, NO TEX'
          if (execTags.length > 0) {
            finishedExercise.tags = execTags.split(',')
            console.log(finishedExercise.tags)
          } else {
            finishedExercise.tags = ''
          }
          let postdata = {
            exercises: finishedExercise,
            // userID TO DO
            lng: 'sl'
          }
          return Rest.request('POST', '/exercises/insertViaInterface', postdata).then((data) => {
            window.jQuery('#modal-addExec').modal('toggle')
            this.latexSuccessfullyImported = true
            this.getExercises()
            this.resetExerciseInterface()
          }).catch((err) => {
            console.log(err)
            this.getExercises()
          })
        }
      },
      uploadBoberFile () {
        let formData = new FormData(window.jQuery('#boberForm')[0])
        return Rest.requestForm('POST', '/importer/insertBoberExercises', formData).then((data) => {
          this.reset()
          alert('Successfully inserted bober exercises')
          this.getExercises()
        }).catch((err) => {
          this.reset()
          this.errorMsg = err
          console.log(err)
        })
      },
      resetNumerical () {
        this.exerciseType = 'any'
        this.numericalQuestion = ''
        this.numericalAnswer = 0
        this.numericalPrecision = 0
        this.numericalHint = ''
        this.addSubExec = !this.addSubExec
      },
      resetRadioAns () {
        this.radioNewAnswer = ''
        this.radioNewChecbox = false
        this.radioAddAnother = false
      },
      resetRadioQuestion () {
        this.exerciseType = 'any'
        this.radioQuestion = ''
        this.radioAllAnswers = []
        this.radioCorrectCount = 0
        this.addSubExec = !this.addSubExec
      },
      resetEssay () {
        this.addSubExec = !this.addSubExec
        this.exerciseType = 'any'
        this.essayQuestion = ''
        this.essayAnswer = ''
        this.essayHint = ''
      },
      resetMultichoice () {
        this.exerciseType = 'any'
        this.multiQuestion = ''
        this.multiAllAnswers = []
        this.addSubExec = !this.addSubExec
      },
      resetExerciseInterface () {
        this.resetNumerical()
        this.resetRadioAns()
        this.resetRadioQuestion()
        this.resetEssay()
        this.resetMultichoice()
        this.execID = ''
        this.execSRC = ''
        this.execExposure = false
        this.execTags = []
        this.execPreText = ''
        this.subExercises = []
      },
      toggleImport () {
        this.successMsg = null
        this.errorMsg = null
        window.jQuery('#modal-import').modal('toggle')
      },
      toggleAddExercise () {
        this.exerciseType = 'any'
        this.newExecInputMethod = 'any'
        window.jQuery('#modal-addExec').modal('toggle')
      },
      toggleNumerical () {
        window.jQuery('#modal-addExec').hide()
        window.jQuery('#modal-numerical').modal('toggle')
      },
      // Upload pictures methods
      togglePictures () {
        window.jQuery('#modal-upload').modal('toggle')
      },
      toggleRating () {
        window.jQuery('#modal-import-rating').modal('toggle')
      },
      toggleEditAns (ansId) {
        if (ansId >= 0) {
          if (this.exerciseType === 'radio') {
            this.ansIndexR = ansId
          }
          if (this.exerciseType === 'multichoice') {
            this.ansIndexM = ansId
          }
          window.jQuery('#modal-editAns').modal('toggle')
        } else {
          window.jQuery('#modal-editAns').modal('toggle')
        }
      },
      toggleShowReports () {
        window.jQuery('#modal-showReports').modal('toggle')
      },
      savePictures (formData) {
        // upload data to the server
        this.currentStatus = STATUS_SAVING
        this.uploadPictures(formData)
        .then(x => {
          this.reset()
          // this.currentStatus = STATUS_SUCCESS
          alert(this.$t('pages.exerciseList.uploadSuccess'))
          window.jQuery('#modal-upload').modal('toggle')
          window.jQuery('#modal-upload').find('input:file').val('')
          // this.$forceUpdate()
        })
        .catch(err => {
          this.reset()
          console.log(err)
          // this.currentStatus = STATUS_FAILED
          alert(this.$t('pages.exerciseList.uploadErrorMsg'))
          window.jQuery('#modal-upload').find('input:file').val('')
        })
      },
      filesChangePictures (fieldName, fileList) {
        if (!fileList.length) return
        this.savePictures()
      },
      filesChangeRating (fieldName, fileList) {
        if (!fileList.length) return
        var form = window.jQuery('.ratingCSVForm')[0] // You need to use standard javascript object here
        var formData = new FormData(form)
        return Rest.requestForm('POST', '/rating/ratingImport', formData).then(x => {
          this.reset()
          // this.currentStatus = STATUS_SUCCESS
          alert(this.$t('pages.exerciseList.uploadRatingSuccess'))
          window.jQuery('#modal-import-rating').modal('toggle')
          window.jQuery('#modal-import-rating').find('input:file').val('')
        })
        .catch(err => {
          this.reset()
          console.log(err)
          // this.currentStatus = STATUS_FAILED
          alert(this.$t('pages.exerciseList.uploadRatingError'))
          window.jQuery('#modal-import-rating').find('input:file').val('')
        })
      },
      downloadRatingCSV () {
        this.loadingCSV = true
        return Rest.requestForm('POST', '/rating/ratingExport', {}).then((data) => {
          if (!data.message) {
            this.loadingCSV = false
            var blob = new Blob([data], {type: 'text/csv;charset=utf-8'})
            saveAs(blob, 'rating.csv')
          } else {
            Rest.Vue.$snotify.error(this.$t('alerts.results'), this.errorThrown)
          }
        })
      },
      uploadPictures () {
        var form = window.jQuery('.slika')[0] // You need to use standard javascript object here
        var formData = new FormData(form)
        return Rest.requestForm('POST', '/upload/exercisePicture', formData)
      },
      toggleShowModal () {
        window.jQuery('#modal-show').modal('hide')
      },
      submitEdit () {
        this.$store.dispatch('submitEditedExercise', {
          exerciseId: this.CelotnaNaloga.exerciseId,
          data: JSON.stringify(this.CelotnaNaloga)
        })
        window.jQuery('#modal-editExercise').modal('hide')
      },
      editExercise (id) {
        this.$store.dispatch('updateModalForExercise', id).then(() => {
          this.$store.commit('updateQuestionObject', {key: 'id', value: id})
          window.jQuery('#modal-editExercise').modal('toggle')
        })
      },
      shortenTitle (title) {
        if (title) {
          var stitle = this.$options.filters.pickTranslation(title)
          if (this.isModal) {
            return stitle.substring(0, 22)
          } else return stitle.substring(0, 28)
        }
      }
    },
    subscriptions () {
      return {
        exerciseSearch: this.$watchAsObservable('sid').map((val) => val.newValue)
        .debounceTime(500)
        .distinctUntilChanged()
        .do({
          next: () => {
            if (this.sqlidentifier === 0) { // start with
              this.sqlsid = this.sid + '%'
            } else {
              this.sqlsid = '%' + this.sid + '%'
            }
            this.spage = 1
            this.getExercises()
          }
        })
      }
    },
    beforeCreate () {
      // console.log('beforeCreate')
    },
    created () {
      this.getExercises()
      this.getOptions()
      if (!this.isModal) {
        this.getSubgroups()
        this.reset()
      }
      // console.log('created')
    },
    beforeMount () {
      // console.log('beforeMount')
    },
    mounted () {
      // console.log('mounted')
    },
    beforeDestroy () {
      // console.log('beforeDestroy')
      this.$store.commit('updateSelectedExercises', [])
    },
    destroyed () {
      // console.log('destroyed')
    },
    watch: {
      selected (val) {
        this.$store.commit('updateSelectedExercises', val)
      }
    }
  }
</script>

<style>

.double {
  width: 1em;
  height: 1em;
}

.icon {
  width: 1em;
}

.modal {
  overflow-y:auto;
}

.box-warning {
  background-color: #f39c12 !important;
  color: white !important;
}

.inputExecInfo {
  margin: 1em;
  color: black;
  font-size: 16px;
}

.inputLatex {
  display: block;
  margin: 0 auto;
  resize: none;
  margin-top: 1em;
  margin-bottom: 1em;
  width: 90%;
  min-height: 20em;
  overflow: scroll;
}

.inputQuestion {
  display: block;
  margin: 0 auto;
  width: 95%;
  padding: 0.5em;
}

.execTypeButton {
  padding: 10px;
  display: block;
  width: 100%;
}

#bober-input {
  margin: 0 auto 2rem auto;
}

.addSubExecButton {
  width: 30%;
  padding: 10px;
}

.submitLatexButton {
  margin: 0 auto;
  margin-top: 2em;
}

.subExercise {
  background-color: #f4f4f4;
  margin-top: 1em;
}

.subExercise:hover {
  background-color: white;
}

.subExercise td {
  padding: 1em;
}

.radioAddAnswer {
  width: 100%;
  margin-top: 2em;
  margin-bottom: 3em;
}

.eyeIconReport {
  border-radius: 100%;
  border: 1px solid#357ca5;
  background-color: white;
}

.eyeIconReport:hover {
  background-color: #357ca5;
  color: white;
}

.reportReactIcon {
  border-radius: 100%;
  background-color: white;
  border: 1px solid#357ca5;
}

.reportReactIcon:hover {
  background-color: #357ca5;
  color: white;
}

#modal-editAns {
  margin-left: 70%;
}

#subExecListHeader {
  width: 100%;
  text-align: center;
  margin-bottom: 2em;
  border-collapse:separate; 
  border-spacing: 0em 1em;
}

#subExecList {
  list-style-type: none;
  padding: 0;
  margin-bottom: 3em;
}

#subExecListRadioAnswers {
  list-style-type: none;
}

#basicExecInfo {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 2em;
  padding-left: 2em;
  padding-right: 2em;
}

#subExecCountInfo {
  margin-top: 2em;
  padding-top: 1em;
  border-top: 1px dashed #357ca5;
}

#soFarAnswers {
  list-style-type: none;
  margin-top: 2em;
  padding: 0;
}

#soFarAnswers li {
  padding: 0.5em;
  margin: 1em;
  border: 1px solid #357ca5;
}

#allReports {
  border: 1px dashed green;
  width: 100%;
  padding: 0;
}

#allReports th {
  font-size: 1.5em;
  text-transform: uppercase;
}

#addTags {
  padding: 0.5em;
  margin-bottom: 1em;
}

#choose-exercise-type {
  margin-top: 2em;
  border-top: 1px dashed #357ca5;
  color: black !important;
  background-color: white !important;
}

#warnings-accordion {
  color: white;
}

#import-modal-body {
  background-color: white !important;
}

</style>


// WEBPACK FOOTER //
// Library.vue?73f125ce